import { Route, Routes, Navigate } from 'react-router-dom'; // Import Navigate
import './App.css';
import Login from './pages/Login';
import PrivateRoute from './hooks/PrivateRoute';
import MainPage from './pages/MainPage';
import ReporteVentas from './pages/ReporteVentas';
import { UserProvider } from './hooks/UserContext';
import ReporteCajas from './pages/ReporteCajas';
import OrdenDeVenta from './pages/OrdenDeVenta';
import PuntoVentaRapido from './pages/PuntoVentaRapido';
import ProductoDetalle from './pages/ProductoDetalle';
import ReporteEstadosCuentasClientes from './pages/ReporteEstadosCuentasClientes';
import ReporteEstadosCuentasProveedores from './pages/ReporteEstadosCuentasProveedores';
import AutorizacionOperacion from './pages/AutorizacionOperacion';
import ListaPrecios from './pages/ListaPrecios';
import ComandaMesa from './pages/ComandaMesa';
import Layout from './pages/Layout';
import UpdateProducto from './pages/UpdateProducto';
import Presupuesto from './pages/Presupuesto';
import { AppConfigProvider } from './hooks/AppConfigContext';
import { LocalesProvider } from './hooks/LocalesContext';
import { ProveedoresProvider } from './hooks/ProveedoresContext';
import PedidoWeb from './pages/PedidoWeb';
import PedidoClienteCarrito from './pages/PedidoClienteCarrito';
import CarritoPublico from './pages/CarritoPublico';
import AdministracionProductos from './pages/AdministracionProductos';
import ModificacionMasivaPrecios from './pages/ModificacionMasivaPrecios';
import Produccion from './pages/Produccion';
import ReporteStockPorLocal from './pages/ReporteStockPorLocal';
import ReporteStockValorizado from './pages/ReporteStockValorizado';
import ReporteHistorialPrecios from './pages/ReporteHistorialPrecios';
import CompraCarga from './pages/CompraCarga';
import ReporteCompras from './pages/ReporteCompras';
import AuditoriaStock from './pages/AuditoriaStock';
import PortalClientes from './pages/PortalClientes';
import EmployeeRoute from './hooks/EmployeeRoute';
import ClientRoute from './hooks/ClientRoute';
import { NotificationProvider } from './hooks/NotificationContext';
import MonitorComandas from './pages/MonitorComandas';
import { RealtimeProvider } from './hooks/RealtimeContext';
import { ProductosVentaProvider } from './hooks/ProductosVentaContext';
import ConMesasRoute from './hooks/ConMesasRoute';
import LogisticaTransportista from './pages/LogisticaTransportista';
import ConexionesIA from './pages/ConexionesIA';
import { permisosReporteIA } from './models/MenuItems';

const App = () => {
  return (
    <div className="App">
      <UserProvider>
        <RealtimeProvider>
        <NotificationProvider>
        <ProductosVentaProvider>
        <LocalesProvider>
        <ProveedoresProvider>
        <AppConfigProvider>
        <div>
          <Routes>
            {/* Redirect root ("/") to "/login" */}
            <Route path="/" element={<Navigate to="/login" replace />} />

            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/carrito" element={<CarritoPublico />} />
            <Route path="/unauthorized" element={<h2>Unauthorized</h2>} />
            <Route path="/productos/:id" element={<ProductoDetalle />} /> {/* Public route */}

            {/* Protected Routes with Layout (Menu persists) */}
            <Route element={<PrivateRoute requiredPermissions={[]} />}>
              <Route element={<Layout />}>
                {/* Main page - shows just the menu prompt */}
                <Route path="/mainpage" element={<MainPage />} />
                
                {/* All other protected routes */}
                <Route element={<ClientRoute />}>
                  <Route element={<PrivateRoute requiredPermissions={["pedidos_clientes"]} />}>
                    <Route path="/clientes/portal" element={<PortalClientes />} />
                    <Route path="/pedidos/carrito" element={<PedidoClienteCarrito />} />
                  </Route>
                </Route>
                <Route element={<EmployeeRoute />}>
                  <Route element={<PrivateRoute requiredPermissions={permisosReporteIA} />}>
                    <Route path="/conexiones-ia" element={<ConexionesIA />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["logistica_transportista"]} />}>
                    <Route path="/logistica/transportista" element={<LogisticaTransportista />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["autorizar_operacion"]} />}>
                    <Route path="/autorizaroperacion" element={<AutorizacionOperacion />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["orden_venta"]} />}>
                    <Route path="/ordenventa" element={<OrdenDeVenta />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["orden_venta"]} />}>
                    <Route path="/puntoventa" element={<PuntoVentaRapido />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["pedidos_clientes"]} />}>
                    <Route path="/pedidoweb" element={<PedidoWeb />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["administrar_productos"]} />}>
                    <Route path="/productos/admin" element={<AdministracionProductos />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["presupuesto"]} />}>
                    <Route path="/presupuesto" element={<Presupuesto />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["reporte_estados_clientes"]} />}>
                    <Route path="/reportes/estadoscuentasclientes" element={<ReporteEstadosCuentasClientes />} />
                    <Route path="/reportes/estadoscuentasproveedores" element={<ReporteEstadosCuentasProveedores />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["reporte_ventas"]} />}>
                    <Route path="/reportes/ventas" element={<ReporteVentas />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["reporte_cajas"]} />}>
                    <Route path="/reportes/cajas" element={<ReporteCajas />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["reporte_stock"]} />}>
                    <Route path="/reportes/stock-local" element={<ReporteStockPorLocal />} />
                    <Route path="/reportes/stock-valorizado" element={<ReporteStockValorizado />} />
                    <Route path="/reportes/auditoria-stock" element={<AuditoriaStock />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["lista_precios"]} />}>
                    <Route path="/listaprecios" element={<ListaPrecios />} />
                    <Route path="/reportes/historial-precios" element={<ReporteHistorialPrecios />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["comanda_mesa"]} />}>
                    <Route element={<ConMesasRoute />}>
                      <Route path="/comandamesa" element={<ComandaMesa />} />
                      <Route path="/monitor-comandas" element={<MonitorComandas />} />
                    </Route>
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["actualizar_precios"]} />}>
                    <Route path="/updateproducto/:id" element={<UpdateProducto />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["actualizar_precios"]} />}>
                    <Route path="/productos/modificacion-precios" element={<ModificacionMasivaPrecios />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["produccion"]} />}>
                    <Route path="/productos/produccion" element={<Produccion />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["compras"]} />}>
                    <Route path="/compras/carga" element={<CompraCarga />} />
                  </Route>
                  <Route element={<PrivateRoute requiredPermissions={["compras"]} />}>
                    <Route path="/compras/reporte" element={<ReporteCompras />} />
                  </Route>
                </Route>
              </Route>
            </Route>

            {/* Catch-All Route for 404 */}
            <Route path="*" element={<h2>404 Not Found</h2>} />
          </Routes>
        </div>
        </AppConfigProvider>
        </ProveedoresProvider>
        </LocalesProvider>
        </ProductosVentaProvider>
        </NotificationProvider>
        </RealtimeProvider>
      </UserProvider>
    </div>
  );
};

export default App;
